import { QueryError } from '../../../common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '../../../common/services';
import { AuthUserSession } from '../auth.interface';
import { AuthKeys } from './auth.keys';

export const useGetSessionAuthMutation = () =>
  buildQuery<AuthUserSession, QueryError>([AuthKeys.GetSession], async () => {
    const { data } = await apiExecutor({
      baseURL: import.meta.env.VITE_AUTHENTICATOR_API_URL,
      url: '/session',
      method: 'GET',
    });
    return data;
  });

export const useLogoutAuthMutation = () =>
  buildMutation<void, QueryError, void>([AuthKeys.Logout], async () => {
    await apiExecutor({
      baseURL: import.meta.env.VITE_AUTHENTICATOR_API_URL,
      url: '/logout',
      method: 'POST',
    });
  });
